export default __webpack_public_path__ + "static/media/cy_logo_desk.720add4f.svg";